var map = {
	"./asx/index.tsx": [
		8945,
		945
	],
	"./core/index.tsx": [
		658,
		658
	],
	"./rfx/index.tsx": [
		7896,
		630,
		896
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3890;
module.exports = webpackAsyncContext;